module.exports = __webpack_public_path__ + "static/media/award-students.ea61c0c5.svg";